import _ from 'lodash'
import React from 'react'
import Dropdown from 'ui/Dropdown'
import TextField from 'ui/molecules/TextField'

import { TriggerUserActions } from '@/components/TriggerUserActions'

import { hasText } from '../../../utils/helpers'
import ZentakeFormContext from '../ZentakeFormContext'

function DropdownQuestion({ question, isOfficeUse, response, sessions, mode }) {
  const formContext = React.useContext(ZentakeFormContext)
  const readonly = formContext.isQuestionReadonly(question)
  const willShowNotAllowedCursor =
    formContext.willShowNotAllowedCursor(question)

  const answer = formContext.getAnswer(question)
  const value = answer && answer.answer_raw ? answer.answer_raw : ''

  const isDirty = formContext.isQuestionDirty(question)
  const isValid = formContext.isQuestionValid(question)
  const questionError = formContext.getQuestionError(question)

  const [hasError, setHasError] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState(
    'This field is required'
  )

  const officeUsePreview = mode === 'preview' && question.is_office_use_only

  React.useEffect(() => {
    setHasError(
      (isDirty && question?.is_required && !isValid) || hasText(questionError)
    )
    setErrorMessage(
      questionError && typeof questionError === 'string'
        ? questionError
        : 'This field is required'
    )
  }, [isDirty, question.is_required, isValid, questionError])

  function handleChange(value) {
    formContext.onAnswerChanged(question, { choiceId: value })
  }

  return readonly ? (
    <TextField
      disabled
      isOfficeUse={isOfficeUse || officeUsePreview}
      isRequired={question.is_required}
      label={question.text}
      value={_.get(
        answer,
        ['answer_choices', 0, 'question_choice', 'text_value'],
        ''
      )}
      willShowNotAllowedCursor={willShowNotAllowedCursor}
    />
  ) : (
    <TriggerUserActions>
      <Dropdown
        data-form-id={response?.form?.id}
        data-packet-id={
          sessions?.fillResponseCustomer?.packetResponse?.packet?.id
        }
        data-response-id={response?.id}
        disabled={readonly}
        errorLabel={errorMessage}
        hasError={hasError}
        inputId={`q-${question.id}`}
        isOfficeUse={isOfficeUse || officeUsePreview}
        isRequired={question.is_required}
        label={question.text}
        onChange={handleChange}
        options={_.orderBy(question.question_choices, ['order'], ['asc']).map(
          (c) => ({
            value: c.id?.toString() || '',
            label: c.text_value,
          })
        )}
        placeholder={question.text}
        value={value}
      />
    </TriggerUserActions>
  )
}

export default DropdownQuestion
